<template>
	<section class="section">
		<div v-if="isAdmin">
			<p>Logged in as: {{ username }}</p>
			<ul>
				<li><a v-on:click="install">Install Design Doc</a></li>
			</ul>
		</div>
		<div v-else-if="username">
			<p>Logged in as: {{ username }}</p>
			<p>Unauthorized</p>
		</div>
		<div v-else>
			<p>Unauthorized <a href="#/login">Login</a></p>
		</div>
	</section>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		data: function () {
			return {
				username: "",
				isAdmin: false,
			}
		},
		created: function() {
			var vm = this

			db.getSession( function( err, response ) {
				if( err ) {
					// network error
					console.log( err )
				} else if( !response.userCtx.name ) {
					// nobody's logged in
					vm.username = ""
				} else {
					// response.userCtx.name is the current user
					vm.username = response.userCtx.name
					vm.isAdmin = ( response.userCtx.roles.indexOf('_admin') > -1 )
				}
			})
		},
		methods: {
			logout: function() {
				db.logOut( function( err, response ) {
					if( err ) {
						alert( err.message )
						console.log( err )
					} else {
						console.log( response )
					}

				})
			},
			install: function() {
				console.log( "installing design doc" )

				db.get( '_design/recipes' ).then( function( currddoc ) {
					return db.put({
						_id: '_design/recipes',
						_rev: currddoc._rev,
						validate_doc_update: function( newDoc, oldDoc, userCtx ) {
							if (!userCtx.name) {
								throw({forbidden : "Only logged in users can modify this database."});
							}
						}.toString(),
						views: {
							categories: {
								map: function( doc ) {
									if( doc.category && doc.name ) {
										// eslint-disable-next-line
										emit( doc.category, 1)
									}
								}.toString(),
								reduce: '_count'
							},
							by_category: {
								map: function( doc ) {
									if( doc.category && doc.name ) {
										// eslint-disable-next-line
										emit( [doc.category, doc.name.replace(/\W/g, '')], {
											name: doc.name,
											category: doc.category
										})
									}
								}.toString()
							},
							by_name: {
								map: function( doc ) {
									if( doc.name )
									{
										// eslint-disable-next-line
										emit( doc.name.replace(/\W/g, ''), {
											name: doc.name,
											category: doc.category
										})
									}
								}.toString()
							},
							tags: {
								map: function( doc ) {
									if( doc.name && doc.tags && doc.tags.length )
									{
										for( var idx in doc.tags )
										{
											var tag = doc.tags[idx].toLowerCase()
											// eslint-disable-next-line
											emit( tag, 1 )
										}
									}
								}.toString(),
								reduce: '_count'
							},
							by_tag: {
								map: function( doc ) {
									if( doc.name && doc.tags && doc.tags.length )
									{
										var alpha = doc.name.replace(/\W/g, '')
										var value = {
											name: doc.name,
											category: doc.category,
											tags: doc.tags
										}

										for( var idx in doc.tags )
										{
											var tag = doc.tags[idx].toLowerCase()

											// eslint-disable-next-line
											emit( [tag, alpha], value )
										}									}
								}.toString()
							},
							by_tags_two: {
								map: function( doc ) {
									if( doc.name && doc.tags && doc.tags.length >= 2 )
									{
										var alpha = doc.name.replace(/\W/g, '')
										var value = {
											name: doc.name,
											category: doc.category,
											tags: doc.tags
										}

										var tagCount = doc.tags.length
										var tags = new Array(tagCount)
										for( var t = 0; t < tagCount; t++ )
										{
											tags[t] = doc.tags[t].toLowerCase()
										}
										tags.sort()

										var idx1 = 0
										var idx2 = 1
										var len = tags.length

										while( idx1 < len -1 )
										{
											while( idx2 < len )
											{
												// eslint-disable-next-line
												emit( [tags[idx1], tags[idx2], alpha], value )
												idx2++
											}
											idx1++
											idx2 = idx1 + 1
										}
									}
								}.toString()
							},
							by_tags_three: {
								map: function( doc ) {
									if( doc.name && doc.tags && doc.tags.length >= 2 )
									{
										var alpha = doc.name.replace(/\W/g, '')
										var value = {
											name: doc.name,
											category: doc.category,
											tags: doc.tags
										}

										var tagCount = doc.tags.length
										var tags = new Array(tagCount)
										for( var t = 0; t < tagCount; t++ )
										{
											tags[t] = doc.tags[t].toLowerCase()
										}
										tags.sort()

										var idx1 = 0
										var idx2 = 1
										var idx3 = 2
										var len = tags.length

										while( idx1 < len - 2 )
										{
											while( idx2 < len - 1 )
											{
												while( idx3 < len )
												{
													// eslint-disable-next-line
													emit( [tags[idx1], tags[idx2], tags[idx3], alpha], value )
													idx3++
												}
												idx2++
												idx3 = idx2 + 1
											}
											idx1++
											idx2 = idx1 + 1
											idx3 = idx1 + 2
										}
									}
								}.toString()
							},
							by_date: {
								map: function( doc ) {
									if( doc.name && doc.created_at )
									{
										// eslint-disable-next-line
										emit( doc.created_at, {
											name: doc.name,
											category: doc.category
										})
									}
								}.toString()
							},
						},
					})
				}).then( function( response ) {
					alert("installed!")
					console.log( response )
				}).catch( function( error ) {
					alert( error.message )
					console.log( error )
				})
			},
		}
	}
</script>
